export default function GradientCountBadge({ children, className = "" }) {
  return (
    <div
      className={`flex size-[44px] shrink-0 items-center justify-center self-start rounded-[5px] ${className}`}
      style={{
        backgroundImage:
          "linear-gradient(91.2573deg, rgb(228, 93, 89) 0%, rgb(89, 100, 160) 100%)",
      }}
    >
      <span className="text-[16px] font-bold leading-none text-white">
        {children}
      </span>
    </div>
  );
}
